
import { Component, Vue, Prop } from "vue-property-decorator";
import { namespace } from "vuex-class";
import { MobileMarker } from "@/store/mobile/types";

import MobileMap from "@/components/mobile/core/MobileMap.vue";

import EventTypes from "@/types/EventTypes";

const Eventqueue = namespace("eventqueue");

import { AlarmQueueFilterID, FilteredEvent } from "@/store/eventqueue/types";
import MobileEventQueueInfoWindow from "./MobileEventQueueInfoWindow.vue";

@Component({
	components: {
		"mobile-map": MobileMap
	}
})
export default class MobileEventQueueMap extends Vue {

    @Eventqueue.Getter("getFilteredEvents") getFilteredEvents!: FilteredEvent[];

    private alarmQueueEvents() : FilteredEvent[] {

		let alarmQueueEvents = this.getFilteredEvents.filter(
			q =>
				q.eventTypeID == EventTypes.Alarm && 
				q.inProcessing == false &&
				q.unParkAt == null &&
				q.isPermanentParked == false &&
				q.readyForPostProcessing == null &&
				q.groupID
		);

		return alarmQueueEvents;
	}

	private alarmQueueMobileMarkers(): MobileMarker[] {

		Vue.extend(MobileEventQueueInfoWindow);
		const mobileInfoWindow = new MobileEventQueueInfoWindow({
			store: this.$store
		}).$mount();

		let mobileMarkers: MobileMarker[] = 
			this.alarmQueueEvents().flatMap((eventQueueItem, index) => {

				return eventQueueItem.locations
						.filter(location => location.location) // only mark events with valid location
						.map(location => {
							let mobileMarker: MobileMarker = {
								id : eventQueueItem.eventID,
								title : `${eventQueueItem.displayTitle} - ${eventQueueItem.groupTitle}`,
								location : this.parseLocationToLatLng(location.location),
								iconURL : 'images/enhancedmapping/bell-solid.svg',
								color: "#00000000", // transparent - hide the circle
								infoWindow: mobileInfoWindow,
								googleMarker: null,
								object: null
							}
							return mobileMarker;
						})
			})

		return mobileMarkers;
	}

    public parseLocationToLatLng(location: string): google.maps.LatLng {
		if (!location) {
			return new google.maps.LatLng(0, 0);
		}

		// Split the location string into a proper Google LatLng object
		let latlng = location.split(",");
		if (latlng.length < 2) {
			latlng = location.split(" ");
		}
		return new google.maps.LatLng(parseFloat(latlng[0]), parseFloat(latlng[1]));
	}

}
